/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface TokenObtainPair
 */
export interface TokenObtainPair {
  /**
   *
   * @type {string}
   * @memberof TokenObtainPair
   */
  username: string;
  /**
   *
   * @type {string}
   * @memberof TokenObtainPair
   */
  password: string;
  /**
   *
   * @type {string}
   * @memberof TokenObtainPair
   */
  readonly access: string;
  /**
   *
   * @type {string}
   * @memberof TokenObtainPair
   */
  readonly refresh: string;
}

/**
 * Check if a given object implements the TokenObtainPair interface.
 */
export function instanceOfTokenObtainPair(value: object): value is TokenObtainPair {
  if (!('username' in value) || value['username'] === undefined) return false;
  if (!('password' in value) || value['password'] === undefined) return false;
  if (!('access' in value) || value['access'] === undefined) return false;
  if (!('refresh' in value) || value['refresh'] === undefined) return false;
  return true;
}

export function TokenObtainPairFromJSON(json: any): TokenObtainPair {
  return TokenObtainPairFromJSONTyped(json, false);
}

export function TokenObtainPairFromJSONTyped(json: any, ignoreDiscriminator: boolean): TokenObtainPair {
  if (json == null) {
    return json;
  }
  return {
    username: json['username'],
    password: json['password'],
    access: json['access'],
    refresh: json['refresh'],
  };
}

export function TokenObtainPairToJSON(value?: Omit<TokenObtainPair, 'access' | 'refresh'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    username: value['username'],
    password: value['password'],
  };
}
